import { FirebaseError } from 'firebase/app';

const messages: Record<string, string> = {
  'auth/invalid-credential': 'Email o password non corretti.',
  'auth/invalid-email': 'Inserisci un indirizzo email valido.',
  'auth/missing-password': 'Inserisci la password.',
  'auth/too-many-requests': 'Troppi tentativi. Attendi qualche minuto e riprova.',
  'auth/user-disabled': 'Questo account è stato disabilitato.',
  'auth/popup-closed-by-user': 'Accesso annullato prima del completamento.',
  'auth/cancelled-popup-request': 'È già in corso un altro tentativo di accesso.',
  'auth/account-exists-with-different-credential': 'Esiste già un account con questa email. Contatta un Superadmin prima di usare Justbit.',
  'auth/internal-error': 'Il tuo account Justbit non è autorizzato ad accedere a Talos.',
  'functions/permission-denied': 'Il tuo account non è autorizzato ad accedere a Talos.',
  'functions/unauthenticated': 'La sessione non è valida. Accedi nuovamente.',
  'functions/failed-precondition': 'L’operazione non può essere completata nello stato attuale.',
  'functions/already-exists': 'Esiste già un account con questi dati.',
  'functions/invalid-argument': 'Controlla i dati inseriti e riprova.',
};

export function authErrorMessage(error: unknown): string {
  if (error instanceof FirebaseError && messages[error.code]) return messages[error.code];
  const code = String((error as { code?: unknown })?.code || '');
  return messages[code] || 'Non è stato possibile completare l’accesso. Riprova.';
}
